import clsx from "clsx";
import { Link } from "./Link";

export function Text({
	className,
	...props
}: React.ComponentPropsWithoutRef<"p">) {
	return (
		<p
			data-slot="text"
			{...props}
			className={clsx(
				className,
				"text-base/6 text-base-content/50 sm:text-sm/6",
			)}
		/>
	);
}

export function TextLink({
	className,
	...props
}: React.ComponentPropsWithoutRef<typeof Link>) {
	return (
		<Link
			{...props}
			className={clsx(
				className,
				"text-base-content underline decoration-base-content/50 data-hover:decoration-base-content",
			)}
		/>
	);
}

export function Strong({
	className,
	...props
}: React.ComponentPropsWithoutRef<"strong">) {
	return (
		<strong
			{...props}
			className={clsx(className, "font-medium text-base-content")}
		/>
	);
}

export function Code({
	className,
	...props
}: React.ComponentPropsWithoutRef<"code">) {
	return (
		<code
			{...props}
			className={clsx(
				className,
				"rounded-sm border border-base-content/10 bg-base-content/5 px-0.5 text-sm font-medium text-base-content sm:text-[0.8125rem]",
			)}
		/>
	);
}
